export const backgroundImageMixin = {
    inject: ['$story'],
    data() {
        return {
            shouldLazyLoad: false,
            isLazyLoaded: false,
        }
    },
    methods: {
        lazyloadBackgroundImage() {
            this.isLazyLoaded = true
        },
    },
    beforeDestroy() {
        if (this.shouldLazyload) this.$lazyload.unload(this.data._uid)
    },
    mounted() {
        this.isLazyLoaded = !this.shouldLazyLoad
        if (this.shouldLazyLoad)
            this.$lazyload.load(this.$el, this.data._uid, this.lazyloadBackgroundImage)
    },
    computed: {
        backgroundImageSrc() {
            // backwards compatibility
            if (this.data.backgroundImage?.filename)
                return this.$storyblok.formatSrc(this.data.backgroundImage.filename)

            let backgroundImage
            let spaceLeft = null

            if (this.$device.isMobile) spaceLeft = this.spaceLeft.mobile
            else if (this.$device.isDesktop) spaceLeft = this.spaceLeft.desktop
            else spaceLeft = this.spaceLeft.tablet

            if (this.data.mobileBackgroundImage?.filename) {
                backgroundImage = this.data.mobileBackgroundImage.filename
            }

            if (this.data.tabletBackgroundImage?.filename && !this.$device.isMobile) {
                backgroundImage = this.data.tabletBackgroundImage.filename
            }

            if (this.data.desktopBackgroundImage?.filename && this.$device.isDesktop) {
                backgroundImage = this.data.desktopBackgroundImage.filename
            }

            const { src } = this.$storyblok.getNormalizedAsset(backgroundImage, spaceLeft)

            return this.$storyblok.formatSrc(src)
        },
        backgroundImageAttrs() {
            if (!this.backgroundImageSrc) return {}

            const backgroundAttrs = {
                class: ['bg-no-repeat bg-center bg-cover'],
            }

            if (this.isLazyLoaded)
                backgroundAttrs.style = { backgroundImage: `url('${this.backgroundImageSrc}')` }

            return backgroundAttrs
        },
    },
    created() {
        if (!this.backgroundImageSrc) return
        this.shouldLazyLoad = this.$story.shouldLazyLoad()
        this.isLazyLoaded = !this.shouldLazyLoad
    },
}
